// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-managemeent-container {
  overflow: hidden;
}
.user-managemeent-container .search-user {
  display: flex;
  gap: 15px;
  width: 50%;
  margin-bottom: 30px;
}
.user-managemeent-container .search-user select {
  width: 50%;
  outline: none;
  padding: 2px;
}
.user-managemeent-container .search-user button {
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  box-shadow: 0px 3px 10px rgba(54, 79, 130, 0.4);
  border-radius: 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  color: #ebe9e9;
  width: 20%;
  height: 2.5rem;
  text-align: center;
  justify-content: center;
  border: none;
}
.user-managemeent-container .search-user button:disabled {
  background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);
}
.user-managemeent-container .user-table .user-state {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}
.user-managemeent-container .user-table .table-responsive-wrapper {
  width: 100%;
  overflow-x: auto;
}
.user-managemeent-container .user-table .table-responsive-wrapper table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;
  min-width: 700px;
}
.user-managemeent-container .user-table .table-responsive-wrapper table th,
.user-managemeent-container .user-table .table-responsive-wrapper table td {
  padding: 12px;
  text-align: left;
}
.user-managemeent-container .user-table .table-responsive-wrapper table tr {
  border-bottom: 1px solid #ddd;
}
.user-managemeent-container .user-table .table-responsive-wrapper table .user-name-column {
  padding-left: 20px;
}
.user-managemeent-container .user-table .table-responsive-wrapper table th {
  background-color: #f4f4f4;
  font-size: 16px;
}
.user-managemeent-container .user-table .table-responsive-wrapper::-webkit-scrollbar {
  height: 6px;
}
.user-managemeent-container .user-table .table-responsive-wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.user-managemeent-container .user-table .pagination-comp {
  margin-top: 2rem;
  margin-bottom: 4rem;
}
.user-managemeent-container .user-table .action-btn {
  display: flex;
  gap: 15px;
}
.user-managemeent-container .user-table .edit-btn {
  background: #47B900;
  border: none;
  cursor: pointer;
  color: white;
  font-size: 16px;
  padding: 8px 7px;
  border-radius: 4px;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user-managemeent-container .user-table .delete-btn {
  background-color: #DA0000;
  border: none;
  cursor: pointer;
  color: white;
  font-size: 16px;
  padding: 8px 7px;
  border-radius: 4px;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 768px) {
  .user-managemeent-container .search-user {
    width: 100%;
  }
  .user-managemeent-container .search-user select {
    width: 80%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/UserManagement/UserManagement.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;AACI;EACI,aAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AACR;AAEI;EACI,UAAA;EACA,aAAA;EACA,YAAA;AAAR;AAGI;EACI,mEAAA;EACA,+CAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;AADR;AAII;EACI,mEAAA;AAFR;AAOQ;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AALZ;AAQQ;EACI,WAAA;EACA,gBAAA;AANZ;AAQY;EACI,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AANhB;AAQgB;;EAEI,aAAA;EACA,gBAAA;AANpB;AASgB;EACI,6BAAA;AAPpB;AAUgB;EACI,kBAAA;AARpB;AAWgB;EACI,yBAAA;EACA,eAAA;AATpB;AAaY;EACI,WAAA;AAXhB;AAcY;EACI,oCAAA;EACA,kBAAA;AAZhB;AAgBQ;EACI,gBAAA;EACA,mBAAA;AAdZ;AAiBQ;EACI,aAAA;EACA,SAAA;AAfZ;AAkBQ;EACI,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhBZ;AAmBQ;EACI,yBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjBZ;;AAsBA;EACI;IACI,WAAA;EAnBN;EAqBM;IACI,UAAA;EAnBV;AACF","sourcesContent":[".user-managemeent-container {\n    overflow: hidden;\n\n    .search-user {\n        display: flex;\n        gap: 15px;\n        width: 50%;\n        margin-bottom: 30px;\n    }\n\n    .search-user select {\n        width: 50%;\n        outline: none;\n        padding: 2px;\n    }\n\n    .search-user button {\n        background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n        box-shadow: 0px 3px 10px rgba(54, 79, 130, 0.4);\n        border-radius: 5px;\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 700;\n        font-size: 16px;\n        display: flex;\n        align-items: center;\n        color: #ebe9e9;\n        width: 20%;\n        height: 2.5rem;\n        text-align: center;\n        justify-content: center;\n        border: none;\n    }\n\n    .search-user button:disabled {\n        background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);\n    }\n\n    .user-table {\n\n        .user-state {\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            max-width: 150px;\n        }\n\n        .table-responsive-wrapper {\n            width: 100%;\n            overflow-x: auto;\n\n            table {\n                width: 100%;\n                border-collapse: collapse;\n                border: 1px solid #ddd;\n                min-width: 700px;\n\n                th,\n                td {\n                    padding: 12px;\n                    text-align: left;\n                }\n\n                tr {\n                    border-bottom: 1px solid #ddd;\n                }\n\n                .user-name-column {\n                    padding-left: 20px;\n                }\n\n                th {\n                    background-color: #f4f4f4;\n                    font-size: 16px;\n                }\n            }\n\n            &::-webkit-scrollbar {\n                height: 6px;\n            }\n\n            &::-webkit-scrollbar-thumb {\n                background-color: rgba(0, 0, 0, 0.2);\n                border-radius: 4px;\n            }\n        }\n\n        .pagination-comp {\n            margin-top: 2rem;\n            margin-bottom: 4rem;\n        }\n\n        .action-btn {\n            display: flex;\n            gap: 15px;\n        }\n\n        .edit-btn {\n            background: #47B900;\n            border: none;\n            cursor: pointer;\n            color: white;\n            font-size: 16px;\n            padding: 8px 7px;\n            border-radius: 4px;\n            width: 35px;\n            height: 35px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n\n        .delete-btn {\n            background-color: #DA0000;\n            border: none;\n            cursor: pointer;\n            color: white;\n            font-size: 16px;\n            padding: 8px 7px;\n            border-radius: 4px;\n            width: 35px;\n            height: 35px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .user-managemeent-container .search-user {\n        width: 100%;\n\n        select{\n            width: 80%;\n        }\n    }\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
